"use client";

/**
 * 상품 상세 라우트 에러 바운더리
 */

interface ProductErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ProductError({ error, reset }: ProductErrorProps) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error("[ProductError]", error);
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <h2 className="text-lg font-semibold">상품을 불러올 수 없습니다</h2>
      <p className="text-muted-foreground text-sm max-w-sm">
        상품 정보를 가져오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.
      </p>
      <button
        onClick={reset}
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
      >
        다시 시도
      </button>
    </div>
  );
}
